import Base from '../base'
import actions from './actions'
import config from './config'
import SPTracker from './trackEvent'
export default class Sensors extends Base {
  constructor (options = {}) {
    super(options)

    this.actions = actions
  }

  async init (options = {}) {}

  trackEvent ({ category, action, label, value }) {
    // console.log('trackEvent',category, action, label, value)
    SPTracker(category, label, value, action)
  }

  setVar (type, params) {}
}
